import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { NgClass } from '@angular/common';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import {
  takeUntilDestroyed,
  toObservable,
  toSignal,
} from '@angular/core/rxjs-interop';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { SidebarService } from '@core/components/sidebar/service/sidebar.service';
import { SidebarItemExpandedLayoutComponent } from '@core/components/sidebar/components/sidebar-item/item/expanded/layout/sidebar-item-expanded-layout.component';

@Component({
  selector: 'app-sidebar-item-expanded-expandable-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, FontAwesomeModule, SidebarItemExpandedLayoutComponent],
  template: `
    <app-sidebar-item-expanded-layout
      [isActive]="isActive()"
      (click)="onClick($event)">
      @if (!isExpanded() && !isActive()) {
        <fa-icon
          class="group-hover:text-greenish-500 pr-2"
          [ngClass]="{ 'text-greenish-500': isActive() }"
          [icon]="['fas', 'chevron-down']"></fa-icon>
      } @else {
        <fa-icon
          class="group-hover:text-greenish-500 pt-1 pr-2"
          [ngClass]="{ 'text-greenish-500': isActive() }"
          [icon]="['fas', 'chevron-up']"></fa-icon>
      }
    </app-sidebar-item-expanded-layout>
  `,
})
export class SidebarItemExpandedExpandableHeaderComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /****/
  private readonly service = inject(SidebarService);

  /****/
  private readonly library = inject(FaIconLibrary);

  /** PROPERTIES **/
  /****/
  protected readonly isExpanded = this.store.isExpanded;

  /****/
  private readonly _activeRoute = toSignal(this.service.routeChanged$);

  /****/
  protected readonly isActive = computed(() =>
    this.store.subPages()!.some(page => page.path === this._activeRoute())
  );

  constructor() {
    this.library.addIcons(faChevronDown, faChevronUp);

    toObservable(this.isActive)
      .pipe(takeUntilDestroyed())
      .subscribe(active => {
        if (active) this.store.setExpanded(true);
      });
  }

  protected onClick(event: Event) {
    if (!this.isActive()) this.store.toggleExpanded();
    event.stopPropagation();
  }
}
